<template>
  <div class="customize-container">
    <img src="@/assets/images/customize-bg.png" alt="" />
    <div class="customize-body">
      <div class="customize-title wow fadeInUp">
        <span>一对一定定制化服务，快速搭建智慧医疗系统</span>
      </div>
      <div class="consult-btn wave wow fadeInUp" @click="openContactCard">
        <span>立即咨询</span>
      </div>
    </div>
    <contact-card ref="contactCard"></contact-card>
  </div>
</template>

<script>
import contactCard from "@/view/components/contactCardDialog";
export default {
  components: {
    contactCard,
  },
  data() {
    return {};
  },
  methods: {
    openContactCard() {
      this.$refs.contactCard.open();
    },
  },
};
</script>

<style lang="scss" scoped>
.customize-container {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  img {
    width: 100%;
  }
  .customize-body {
    position: absolute;
    top: 20%;
    bottom: 25%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    .customize-title {
      font-family: PingFangSC-Semibold;
      font-size: 30px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
    }
    .consult-btn {
      // margin-top: 5%;
      width: 104px;
      height: 34px;
      background: #ffa219;
      border-radius: 17px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #ffffff;
      @include btn;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/common/customize.vue